module.exports = __webpack_public_path__ + "img/truemoney2.219bbe66.png";